module.exports = __webpack_public_path__ + "static/media/apply_success.2156b72b.svg";